import CarteiraConstans from "../../../../carteira/src/infra/data/carteiraConstants"
import { Post } from "domain/infra/data/api"
import { PagarRequest } from "domain/types/_carteira/premiacao/pagarRequest"
import { PixRequest } from "domain/types/_carteira/premiacao/pixRequest"
import { PixResponse } from "domain/types/_carteira/premiacao/pixResponse"
import { PagarResponse } from "domain/types/_carteira/premiacao/pagarResponse"

export class PremiacaoService {
  constructor() {
    //super()
  }

  async ValidarPix(data: PixRequest, carteiraId: number): Promise<PixResponse | Error> {
    return await Post(CarteiraConstans.apiCarteira.carteira.validarPix(carteiraId), data)
  }

  async Pagar(data: PagarRequest[], carteiraId: number): Promise<PagarResponse[] | Error> {
    return await Post(CarteiraConstans.apiCarteira.carteira.pagar(carteiraId), data)
  }
}
